import React from 'react';

import { Grid, Paper } from '@material-ui/core';

import { ScoreType } from '../../../../../../store/admin/eventFormats/store';

import trophy from '../../../../../../assets/images/trophy.png';
import { ICombination } from '../../AssignResults/Context/AssignResults.context';

interface ICombinationCard {
  combination: ICombination;
  onClick: any;
}

export const CombinationCard = (props: ICombinationCard) => {
  const {
    combination: {
      format: {
        format: { name: formatName, prefix }
      },
      scoreType,
      flight,
      hasAwards,
      aggregation
    },
    onClick
  } = props;

  const flightName = flight ? flight.name : 'All';

  const formattedFormatName = aggregation
    ? aggregation === 1
      ? `TEAMS TOTAL SCORE`
      : `TEAMS BEST BALL`
    : formatName;

  const isGBNorCTP = prefix.includes('gbn') || prefix.includes('ctp');

  return (
    <Paper elevation={1} className="paper combination" onClick={onClick}>
      <Grid className="grid" container={true} spacing={0}>
        <Grid className="grid-item" item={true} xs={9}>
          <div className="container">
            <p className="flight">{flightName}</p>

            <p className="format">{formattedFormatName}</p>
          </div>
        </Grid>

        <Grid className="grid-item" item={true} xs={2}>
          <div className="container">
            {!isGBNorCTP && <p className="net">{ScoreType[scoreType]}</p>}
          </div>
        </Grid>

        <Grid className="grid-item" item={true} xs={1}>
          <div className="container">{hasAwards && <img src={trophy} alt="trophy" />}</div>
        </Grid>
      </Grid>
    </Paper>
  );
};
